import * as React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

export interface ModalNotificationProps {
    showModal: boolean;
    modalMessage: string;
    onClose: () => void;
}

export class ModalNotification extends React.Component<ModalNotificationProps> {

    render() {
        if (!this.props.modalMessage) {
            return null;
        }
        return (
            <Modal isOpen={this.props.showModal} toggle={this.props.onClose}>
                <ModalHeader toggle={this.props.onClose}>Notification</ModalHeader>
                <ModalBody>
                    {this.props.modalMessage}
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={this.props.onClose}>OK</Button>
                </ModalFooter>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/utils/modalNotification.tsx